(function(){
  var REBUY=/cdn\.rebuyengine\.com\/onsite\/js\/rebuy\.js/i,loaded=false;

  // если скрипт уже есть в документе — пометим
  for (var i=0;i<document.scripts.length;i++){
    var s=document.scripts[i]; if (s.src && REBUY.test(s.src)) { loaded=true; break; }
  }

  // перехват .src
  var d=Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype,'src');
  if(d&&d.set){
    Object.defineProperty(HTMLScriptElement.prototype,'src',{
      configurable:true,
      get:d.get,
      set:function(v){
        if(typeof v==='string' && REBUY.test(v)){
          if(loaded) return;               // тихо игнорируем повтор
          loaded=true; window.__REBUY_LOADED__=true;
        }
        return d.set.call(this,v);
      }
    });
  }

  // перехват setAttribute('src', ...)
  var _set=Element.prototype.setAttribute;
  Element.prototype.setAttribute=function(name,val){
    if(this.tagName==='SCRIPT' && String(name).toLowerCase()==='src' && typeof val==='string' && REBUY.test(val)){
      if(loaded) return;                   // повтор — игнор
      loaded=true; window.__REBUY_LOADED__=true;
    }
    return _set.apply(this,arguments);
  };
})();